const sdkConfig = {
    webVersion: "-V171.043.2000.07", // 网页 版本
    mixpanelwebVersion: "1.0.0",//main-page埋点版本号
    emailAddress: "contact-us@7mfitness.com", //联系我们-公司邮箱地址
    fbqName: "",
    ga4Name: '',
    ga4MeasurementID: 'G-HWFEFVRV0X',
    ga4AwID: 'AW-17010801886',
    ga4AwEventID: "x5uiCJrOqb0aEN75sK8_",
    ga4DebugMode: false, //开启debuger模式
    useAppsFlyer: true,//是否开启AppsFlyer
    paypalConfig: {
        clientId: 'ARpaNX5VvtVG0Fw-7AS8a_oBL23XuWkuMDWb4rHrpH18OMK-cm9n9yjnkFiEG50JUnUQMLOA1wVaaDYD', //PayPal 支付clientid
    },
    apiConfig: {
        systemBaseUrl: 'https://furina.7mfitness.com',
        stripeBaseUrl: 'https://api.revenuecat.com/v1',

    },
    statsigConfig: {
        statsigClientKey: 'client-pit9UptOZp4pl3qWvJnoh02qce3S2Hw1ldHZrXvu72x',
        //paywall
        paywallExperimentName: "sep24th_paywallcombooptimization_experiment",
        paywallParamName: "flow_version",
        defaultPaywallParam: 'base',
        selectPaywallParam: 'new',
        //price:control_price (我们当前的价格);reduced_price (降价);increased_price (涨价)
        priceExperimentName: "nov01th_paywallprice_experiment",
        priceParamName: "pricing_tier",
        defaultPriceParam: 'control_price',
        selectPriceParam: 'reduced_price',
        //下载二维码和深链接
        cppParameterExperimentName: "dec16th_cpp_experiment",
        cppParameterParamName: "cpp_parameter",
        defaultCppParameterParam: 'base',
        selectCppParameterParam: 'new',
        //ageGroup页面设计design
        ageGroupDesignExperimentName: "landing_page_design_test_jan20th",
        ageGroupDesignParamName: "design",
        defaultAgeGroupDesignParam: 'default',
        selectAgeGroupDesignParam: 'test',
        //ageGroup图片
        ageGroupExperimentName: "oct29th_agegroup_experiment",
        ageGroupParamName: "age_group_id",
        defaultAgeGroupParam: 'age_group_1',
        selectAgeGroupParam: 'age_group_3',
        tier: 'development', // development ,production
    },
    firebaseConfig: {
        apiKey: "AIzaSyDdViGK9qArf7WhFr408k9xlt0G8RdFzZ4",
        authDomain: "oog116-q7cpe.firebaseapp.com",
        databaseURL: "https://oog116-q7cpe.appspot.com",
        projectId: "oog116-q7cpe",
        storageBucket: "oog116-q7cpe.appspot.com",
        messagingSenderId: "656117880719",
        appId: "1:656117880719:web:c2e5eca1aa42da7dd2ddfa",
        measurementId: "G-BTHVV0Y7QV",
        defaultCollectionPath: 'web2app_116'
    },
    stripeConfig: {
        revenuecatStripeAppPublicApiKey: "sk_MFtVmujJoVFifpbJiGYzlBpLaRAKT",
        stripeKey: "pk_live_51O5L81DOSX8YAb7RgMgytMC7ddW6L3CLBm5FOMAX8xh00VbRiqTvrM4YDdjz2kqZgRjRL528hXMmgMXdzykOTnoZ00ws1Rin9J",
    },
    mixpanelConfig: {
        token: '946337560e0d43a9f9bf787ea76d74e8',
        onboardingEventKey: 'OB',
        homePageEventKey: '1st',
        purchaseKey: 'OB',
        designId: "Web-Paywall-3prices",//paywall页面id
    },
}
export default sdkConfig